import React, { useEffect, useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { VolumeList } from "./Volumes/VolumeList";
import { TemplateList } from "./Templates/TemplateList";
import { FolderList } from "./Folders/FolderList";
import { EContentService } from "../../globals/services/enhancedContent.service";
import moment from "moment";
import { EventsService } from "../../globals/services/events.service";
import { useSelector } from "react-redux";
import CurriculaNavBar from './components/CurriculaNavBars/curriculaNavBar';
import NewAsset from './components/Assets/NewAsset';
import styles from './Dashboard.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import Pagination from './components/Pagination';
import { PAGE_SIZE, FOLDER_PAGE_SIZE, TABS } from './constants/index';

export const FTJDashboard = () => {
    const history = useHistory();
    const location = useLocation();
    const { curriculaActiveTab } = location?.state || { curriculaActiveTab: TABS.VOLUMES };

    const [activeTab, setActiveTab] = useState(curriculaActiveTab);
    const [adminUsers, setAdminUsers] = useState([]);
    const [templateList, setTemplateList] = useState([]);
    const [seminarList, setSeminarList] = useState([]);
    const [volumeCount, setVolumeCount] = useState(0);
    const [templateCount, setTemplateCount] = useState(0);
    const [folderCount, setFolderCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const eContentService = EContentService();
    const eventService = EventsService();

    const { me } = useSelector((state) => state.auth);

    useEffect(() => {
        let isMounted = true;

        if (me) {
            eContentService.getAdminUsers().then((res) => {
                if (isMounted) {
                    setAdminUsers(res.data);
                }
            });
            
            eContentService.getActiveTemplateList().then((res) => {
                if (isMounted) {
                    setTemplateList(res.data);
                }
            });

            eventService.getEventItems().then((res) => {
                if (isMounted) {
                    const dateThreeMonthsAgo = moment().subtract(12, 'months').format('YYYY-MM-DD');
                    setSeminarList(res.filter(
                        (item) => item.event.dtEndDate && moment(item.event.dtEndDate).format('YYYY-MM-DD') > dateThreeMonthsAgo
                    ));
                }
            });
        }

        return () => {
            isMounted = false;
        };
    }, [me]);

    useEffect(() => {
        activeTab === '1' && setTotalPages(Math.ceil(volumeCount / PAGE_SIZE));
        activeTab === '2' && setTotalPages(Math.ceil(templateCount / PAGE_SIZE));
        activeTab === '3' && setTotalPages(Math.ceil(folderCount / FOLDER_PAGE_SIZE));
    }, [volumeCount, templateCount, folderCount, activeTab]);

    const handleVolumeCountUpdate = (count) => setVolumeCount(count);
    const handleTemplateCountUpdate = (count) => setTemplateCount(count);
    const handleFolderCountUpdate = (count) => setFolderCount(count);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const navigateToVolumePage = (volumeItem = null) => history.push("/volume", volumeItem ? { volumeItem } : undefined);
    const navigateToTemplatePage = (templateItem = null) => {
      if (templateItem) {
        history.push(`/template/${templateItem._id}`);
      } else {
        history.push("/template");
      }
    };
    const navigateToFolderPage = (folderItem = null) => history.push("/folder", folderItem ? { folderItem } : undefined);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
        // Update location state to persist the selected tab
        history.replace(location.pathname, { 
            ...location.state, 
            curriculaActiveTab: tab 
        });
    }

    return (
        <div className="content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className={styles.header}>
                        <div>
                            <h1 className={styles.title}>Curricula Module</h1>
                            <h2 className={styles.description}>
                                Here you can manage Volumes, Templates and their contents (in Folders)
                            </h2>
                        </div>
                        <NewAsset
                            createNewVolume={navigateToVolumePage}
                            createNewTemplate={navigateToTemplatePage}
                            createNewFolder={navigateToFolderPage}
                        />
                    </div>
                    <div className={styles.section}>
                        <CurriculaNavBar
                            activeTab={activeTab}
                            setActiveTab={handleTabChange}
                            volumeCount={volumeCount}
                            templateCount={templateCount}
                            folderCount={folderCount}
                        />
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId={TABS.VOLUMES}>
                                <VolumeList
                                    navigateToVolumePage={navigateToVolumePage}
                                    updateVolumeCount={handleVolumeCountUpdate}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </TabPane>
                            <TabPane tabId={TABS.TEMPLATES}>
                                <TemplateList
                                    onCountUpdate={handleTemplateCountUpdate}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    navigateToTemplatePage={navigateToTemplatePage}
                                />
                            </TabPane>
                            <TabPane tabId={TABS.FOLDERS}>
                                <FolderList 
                                    seminarList={seminarList} 
                                    templateList={templateList} 
                                    adminUsers={adminUsers} 
                                    navigateToFolderPage={navigateToFolderPage} 
                                    onCountUpdate={handleFolderCountUpdate}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </TabPane>
                        </TabContent>
                    </div>
                    {totalPages > 1 && (activeTab === '1' || activeTab === '2' || activeTab === '3') && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

